<template>
  <div class="">
    <navbar></navbar>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <router-link to="top">{{$t('ordertop.myhome')}}</router-link> / <router-link to="order-list">{{$t('OrderListTop.OrderList')}}</router-link>
          <div class="accordion mt-4" id="accordionExample">
            <div class="card">
              <div class="card-header p-0" id="headingOne">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {{$t('orderlist.AppInfo')}}
                  </button>
                </h2>
              </div>
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="number">{{$t('SearchColumn.NO')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input class="form-control" id="number" type="text" :value="orderInfo.order_no" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="applicationTime">{{$t('DisplayBar.Application')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="applicationTime" :value="moment(orderInfo.order_apply_time).format('YYYY-MM-DD HH:mm:ss')" aria-label="Recipient's username" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="updateTime">{{$t('DisplayBar.UpdateTime')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="updateTime" :value="moment(orderInfo.order_update_time).format('YYYY-MM-DD HH:mm:ss')" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>

                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="status">{{$t('SearchColumn.Status')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="status" :value="getStatus(status)" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingTwo">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    {{$t('orderlist.userInfo')}}
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="name">{{$t('orderlist.name')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input class="form-control" id="name" type="text" :value="orderInfo.user_name" readonly>
                      </div>

                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="email">{{$t('orderlist.email')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="email" class="form-control" id="email" :value="orderInfo.user_email" aria-label="Recipient's username" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="tel">{{$t('orderlist.tel')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="tel" :value="orderInfo.user_telephone" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingThree">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    {{$t('orderlist.Transaction')}}
                  </button>
                </h2>
              </div>
              <div id="collapseThree" class="collapse show" aria-labelledby="headingThree">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="coinPaymentAddress">{{$t('orderlist.CoinPS')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input class="form-control" type="text" id="coinPaymentAddress" :value="orderInfo.payment_address" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="coinAmount">{{$t('orderlist.CoinA')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">{{orderInfo.payment_coin_type}}</span>
                        </div>
                        <input type="number" id="coinAmount" class="form-control" :value="orderInfo.payment_coin_amount" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="coinTXID">{{$t('orderlist.CoinTXID')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="coinTXID" v-model="orderInfo.payment_txid" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4 pr-0">
                      <label class="navbar-brand pr-0" for="evidence">{{$t('orderlist.Evidence')}}<a tabindex="0" class="btn btn-sm border-0 p-0 mb-1" role="button" rel="evidence" data-toggle="popover" data-trigger="focus" :title="$t('orderListPopup.Evidence')" data-content=""><img src="../../../static/img/info.svg"></a></label>
                    </div>
                    <div class="form-inline col-12 col-md-8 justify-content-between" style="height:120px">
                      <a href="#" id='saveAs' data-toggle="modal" v-if="imgURL!==''" data-target="#enlargeModal"><img :src="imgURL" height="100px" title="click to enlarge"></a>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand">{{$t('orderlist.Category')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <label for="isFairFx">{{$t('orderlist.isFairFX')}}</label>
                      <input type="radio" class="mr-4" :value="1" v-model="orderInfo.receive_account_type" id="isFairFx" disabled>
                      <label for="notFairFx">{{$t('orderlist.notFairFx')}}</label>
                      <input type="radio" :value="2" v-model="orderInfo.receive_account_type" id="notFairFx" disabled>
                    </div>
                  </nav>
                  <nav class="navbar col-12" v-if="orderInfo.receive_account_type === 1">
                    <div class="col-12 col-lg-4">
                      <label for="fairFX" class="navbar-brand">{{$t('orderlist.FairFXnum')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input type="text" class="form-control" id="fairFX" v-model="orderInfo.fairfx_number" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <div v-if="orderInfo.receive_account_type === 2">
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="accountHolderName" class="navbar-brand">{{$t('UpdateInfoForm.accountHolderName')}}</label>
                        <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" title="Account holder name" data-content="Please enter the account holder name"><img src="../../../static/img/info.svg"></a>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="accountHolderName" v-model="orderInfo.account_name" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="firstName" class="navbar-brand">{{$t('UpdateInfoForm.firstName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="firstName" v-model="orderInfo.first_name" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="lastName" class="navbar-brand">{{$t('UpdateInfoForm.lastName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="lastName" v-model="orderInfo.last_name" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="street" class="navbar-brand">{{$t('UpdateInfoForm.myResidence')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" id="street" v-model="orderInfo.account_street" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="city" class="navbar-brand">{{$t('UpdateInfoForm.mycity')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="city" v-model="orderInfo.account_city" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="postcode" class="navbar-brand">{{$t('UpdateInfoForm.myPostalCode')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="postcode" v-model="orderInfo.account_postcode" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="country" class="navbar-brand">{{$t('UpdateInfoForm.mycountry')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="country" v-model="orderInfo.account_country" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="accountNumber" class="navbar-brand">{{$t('UpdateInfoForm.accountNumber')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="accountNumber" v-model="orderInfo.account_number" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="bankName" class="navbar-brand">{{$t('UpdateInfoForm.bankName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankName" v-model="orderInfo.bank_name" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="bankStreet" class="navbar-brand">{{$t('UpdateInfoForm.bankStreet')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankStreet" v-model="orderInfo.bank_street" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="bankCountry" class="navbar-brand">{{$t('UpdateInfoForm.bankCountry')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankCountry" v-model="orderInfo.bank_country" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="bankSWIFT" class="navbar-brand">{{$t('UpdateInfoForm.bankSWIFT')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group p-0 col-12">
                          <input type="text" class="form-control" id="bankSWIFT" v-model="orderInfo.bank_swift" style="border-bottom-right-radius:0.35rem;border-top-right-radius:0.35rem;" aria-describedby="basic-addon2" readonly>
                          <label for="routing" class="navbar-brand ml-3">{{$t('UpdateInfoForm.routing')}}</label>
                          <input type="text" class="form-control" id="routing" v-model="orderInfo.bank_routing" style="border-bottom-left-radius:0.35rem;border-top-left-radius:0.35rem;" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="IBAN" class="navbar-brand">{{$t('UpdateInfoForm.IBAN')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="IBAN" v-model="orderInfo.account_iban" aria-describedby="basic-addon2" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label for="BACS" class="navbar-brand">{{$t('UpdateInfoForm.BACS')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="custom-control custom-checkbox p-0 pl-4">
                          <input id="BACS" class="custom-control-input" type="checkbox" v-model="orderInfo.bank_bacs_sepa" aria-label="Checkbox for following text input" disabled>
                          <label class="custom-control-label" for="BACS"></label>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingFour">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    {{$t('orderlist.ExchangeRIR')}}
                  </button>
                </h2>
              </div>
              <div id="collapseFour" class="collapse show" aria-labelledby="headingFour">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="rate">{{$t('orderlist.ConfirmEdexchangeRateR')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <input class="form-control" type="text" id="rate" v-model="orderInfo.exchange_estimated_rate" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2">USD/{{orderInfo.payment_coin_type}}</span>
                        </div>
                      </div>

                    </div>
                  </nav>
                  <nav class="navbar">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="amount">{{$t('orderlist.ConfirmedAmountR')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">USD</span>
                        </div>
                        <input type="number" id="amount" class="form-control" v-model="orderInfo.exchange_estimated_amount" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label class="navbar-brand" for="serviceCharge">{{$t('orderlist.ServiceChargeR')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-8">
                      <div class="input-group col-12 p-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">USD</span>
                        </div>
                        <input type="number" class="form-control" id="serviceCharge" v-model="orderInfo.exchange_estimated_service_charge" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingFive">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    {{$t('orderlist.ExchangeRI')}}
                  </button>
                </h2>
              </div>
              <div id="collapseFive" class="collapse show" aria-labelledby="headingFive">
                <div class="card-body">
                  <form label-width="0px" class="demo-ruleForm pt-4 needs-validation" novalidate>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="copperRate">{{$t('orderlist.ConfirmCopperRate')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" type="number" min='0.00' step='0.01' id="copperRate" v-model="exchange_copper_rate" @blur="format" :readonly="status!=='RA'" required>
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2" style="border-bottom-right-radius:0.35rem;border-top-right-radius:0.35rem;">USD/{{orderInfo.payment_coin_type}}</span>
                          </div>
                          <div class="invalid-feedback">
                            {{$t('orderlist.copperRateRequired')}}
                          </div>
                        </div>
                      </div>
                      <small v-if="showLower" class="text-danger col-12 offset-lg-4 col-lg-8" v-html="$t('orderlist.lower')"></small>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="newRate">{{$t('orderlist.ConfirmEdexchangeRate')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" type="number" id="newRate" :value="orderInfo.exchange_rate" readonly>
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2" style="border-bottom-right-radius:0.35rem;border-top-right-radius:0.35rem;">USD/{{orderInfo.payment_coin_type}}</span>
                          </div>
                          <div class="invalid-feedback">
                            {{$t('orderlist.newRateRequired')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="newAmount">{{$t('orderlist.ConfirmedAmount')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon2">USD</span>
                          </div>
                          <input type="number" id="newAmount" class="form-control" :value="orderInfo.exchange_amount" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-lg-4">
                        <label class="navbar-brand" for="newServiceCharge">{{$t('orderlist.ServiceCharge')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon2">USD</span>
                          </div>
                          <input type="number" class="form-control" id="newServiceCharge" :value="orderInfo.exchange_service_charge" readonly>
                        </div>
                      </div>
                    </nav>
                  </form>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header p-0" id="headingSix">
                <h2 class="mb-0">
                  <button class="btn btn-link col-12 text-left p-3 pl-5 collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    {{$t('orderlist.ContactMatters')}}
                  </button>
                </h2>
              </div>
              <div id="collapseSix" class="collapse show" aria-labelledby="headingSix">
                <div class="card-body">
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label for="userMessage" class="navbar-brand">{{$t('orderlist.Usermessage')}} ({{$t('orderlist.mailLanguage')}} : {{userLanguageCode(orderInfo.language_code)}})</label>
                    </div>
                    <div class="form-inline col-12 col-md-12">
                      <div class="input-group col-12 p-0">
                        <textarea class="form-control" id="userMessage" v-model="orderInfo.message_user" rows="3" readonly></textarea>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label for="operatorMessage" class="navbar-brand">{{$t('orderlist.Operatormessage')}}</label>
                    </div>
                    <div class="form-inline col-12 col-md-12">
                      <div class="input-group col-12 p-0">
                        <textarea class="form-control" maxlength="255" id="operatorMessage" v-model="orderInfo.message_operator" rows="3"></textarea>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-between mt-4 mr-3">
            <div class="justify-content-start p-0 ml-3">
              <router-link to="order-list" class="btn btn-outline-secondary">{{$t('status.back')}}</router-link>
            </div>
            <div class="row justify-content-end p-0">
              <button type="button" class="btn btn-outline-secondary mr-2" @click="submit('save')">{{$t('status.save')}}</button>
              <button type="button" class="btn btn-danger mr-2" @click="submit('C')" v-if="statusChangeToNo()===3||statusChangeToNo()===5||statusChangeToNo()===6">{{$t('status.cancel')}}</button>
              <button type="button" class="btn btn-warning mr-2" @click="submit('AC')" v-if="statusChangeToNo()===3">{{$t('status.reSubmit')}}</button>
              <button type="button" class="btn btn-primary" @click="submit('RA')" v-if="statusChangeToNo()===3">{{$t('status.receipt')}}</button>
              <button type="button" class="btn btn-primary" @click="submit('CR')" v-if="statusChangeToNo()===5">{{$t('status.rateConfirm')}}</button>
              <button type="button" class="btn btn-success" @click="submit('PC')" v-if="statusChangeToNo()===6">{{$t('status.transferred')}}</button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <copyright></copyright>
    <div class="modal fade" id="enlargeModal" style="z-index:111111" tabindex="-1" role="dialog" aria-labelledby="enlargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <img :src="imgURL" style="margin: 0 auto;max-width:100%" />
      </div>
    </div>

    <div class="modal fade" id="generalModal" tabindex="-1" role="dialog" aria-labelledby="generalModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('orderInfoModal.title')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center pt-0">
            <div class="m-4">
              <span v-if="newStatus === status">{{$t('orderInfoModal.save')}}</span>
              <span v-if="newStatus !== status">
                <span v-if="newStatus === 'AC'">{{$t('orderInfoModal.statusAC')}}</span>
                <span v-if="newStatus === 'C'">{{$t('orderInfoModal.statusC')}}</span>
                <span v-if="newStatus === 'RA'">{{$t('orderInfoModal.statusRA')}}</span>
                <span v-if="newStatus === 'CR'">{{$t('orderInfoModal.statusCR')}}</span>
                <span v-if="newStatus === 'PC'">{{$t('orderInfoModal.statusPC')}}</span>
              </span>
            </div>
            <div class="card mb-3">
              <div class="card-body">
                <div v-if="oldOrderInfo.exchange_copper_rate!==orderInfo.exchange_copper_rate&&newStatus !== 'C'">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderInfoModal.copperRate')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <input type="text" class="form-control" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" :value="oldOrderInfo.exchange_copper_rate" aria-describedby="basic-addon2" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2">USD/{{orderInfo.payment_coin_type}}</span>
                        </div>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <input type="text" class="form-control  border-success" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" :value="orderInfo.exchange_copper_rate" aria-describedby="basic-addon2" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text border-success change" id="basic-addon2">USD/{{orderInfo.payment_coin_type}}</span>
                        </div>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="oldOrderInfo.exchange_rate!==orderInfo.exchange_rate&&newStatus !== 'C'">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderInfoModal.rate')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <input type="text" class="form-control" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" :value="oldOrderInfo.exchange_rate" aria-describedby="basic-addon2" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2">USD/{{orderInfo.payment_coin_type}}</span>
                        </div>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <input type="text" class="form-control  border-success" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" :value="orderInfo.exchange_rate" aria-describedby="basic-addon2" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text border-success change" id="basic-addon2">USD/{{orderInfo.payment_coin_type}}</span>
                        </div>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="oldOrderInfo.exchange_amount!==orderInfo.exchange_amount&&newStatus !== 'C'">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderInfoModal.amount')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">

                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <div class="input-group-prepend">
                          <span class="input-group-text" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" id="basic-addon2">USD</span>
                        </div>
                        <input type="text" class="form-control" :value="oldOrderInfo.exchange_amount" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <div class="input-group-prepend">
                          <span class="input-group-text border-success" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" id="basic-addon2">USD</span>
                        </div>
                        <input type="text" class="form-control border-success change" :value="orderInfo.exchange_amount" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="oldOrderInfo.exchange_service_charge!==orderInfo.exchange_service_charge&&newStatus !== 'C'">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderInfoModal.charge')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">

                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <div class="input-group-prepend">
                          <span class="input-group-text" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" id="basic-addon2">USD</span>
                        </div>
                        <input type="text" class="form-control" :value="oldOrderInfo.exchange_service_charge" aria-describedby="basic-addon2" readonly>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <div class="input-group-prepend">
                          <span class="input-group-text border-success" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" id="basic-addon2">USD</span>
                        </div>
                        <input type="text" class="form-control border-success change" :value="orderInfo.exchange_service_charge" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
                <div v-if="orderInfo.message_operator!==oldOrderInfo.message_operator">
                  <nav class="navbar">
                    <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderInfoModal.operatorMessage')}}</div>
                    <div class="form-inline col-12 col-lg-8 justify-content-lg-between">

                      <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                        <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <textarea class="form-control" id="exampleFormControlTextarea1" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" rows="3" v-model="oldOrderInfo.message_operator" readonly></textarea>
                      </div>
                      <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                        <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left"></label>
                        <textarea class="form-control border-success change" id="exampleFormControlTextarea1" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" rows="3" v-model="orderInfo.message_operator" readonly></textarea>
                      </div>
                    </div>
                  </nav>
                </div>
                <nav class="navbar">
                  <div class="navbar-brand col-12 col-lg-3 mt-4">{{$t('orderInfoModal.status')}}</div>
                  <div class="form-inline col-12 col-lg-8 justify-content-lg-between">
                    <div class="input-group col-12 col-lg-5 pl-0 pr-0">
                      <label v-html="$t('orderlist.before')" class="col-12 justify-content-start pl-0 text-left"></label>
                      <input type="text" class="form-control" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" :value="getStatus(status)" aria-describedby="basic-addon2" readonly>
                    </div>
                    <div class="input-group col-12 col-lg-5 pl-0 mr-lg-5 pr-0 mt-2 mt-lg-0">
                      <label v-html="$t('orderlist.after')" class="col-12 justify-content-start pl-0 text-left"></label>
                      <input type="text" class="form-control border-success change" style="border-top-left-radius:0.35rem;border-bottom-left-radius:0.35rem;" :value="getStatus(newStatus)" aria-describedby="basic-addon2" readonly>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div class="modal-footer pt-5 pb-3">
            <div class="col-6 text-left">
              <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
              </button>
            </div>
            <div class="col-6 text-right">
              <button class="btn btn-lg btn-primary" @click="update" data-dismiss="modal">{{$t('modal.modalOk')}}</button>
            </div>
          </div>

        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

    <div class="modal fade" id="successModal" tabindex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('orderInfoModal.successTitle')}}</h5>
            <button type="button" class="close" data-dismiss="modal" @click="init" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="p-4" v-if="status!==newStatus">{{$t('orderListPopup.change')}}</h5>
            <h5 class="p-4" v-if="status===newStatus">{{$t('orderListPopup.savesuccessful')}}</h5>
            <router-link to="order-list" class="btn btn-primary btn-lg popover-test mb-4" data-dismiss="modal">{{$t('orderInfoModal.successButton')}}</router-link>
          </div>

        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

  </div>

</template>
<style />
<script type="text/javascript">
import navbar from './navbar'
import copyright from '../user/copyright'
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import Cookies from 'js-cookie'
let orderInfoGetType = 'operator-order-info-get'
let orderInfoUpdateType = 'operator-order-info-update'
let getServiceChargeType = 'operator-get-service-charge'
let thisVue = null
const moment = require('moment')
export default {
  components: { navbar, copyright },
  data: function () {
    return {
      orderInfo: '',
      oldOrderInfo: '',
      status: '',
      newStatus: '',
      orderNo: '',
      imgURL: '',
      exchange_copper_rate: '',
      service_charge: '',
      servicefee_real: '',
      notRequest: '',
      moment: moment,
      showLower: false
    }
  },
  mounted() {
    this.orderNo = this.$route.query.order_no
    this.init()
    thisVue = this
    $('[rel=evidence]').popover({
      html: true,
      content: function () {
        return thisVue.$t('orderListPopup.EvidenceTips')
      }
    })
  },
  methods: {
    getStatus(status) {
      switch (status) {
        case 'AC':
          return this.$t('status.AC')
        case 'GU':
          return this.$t('status.GU')
        case 'WC':
          return this.$t('status.WC')
        case 'C':
          return this.$t('status.C')
        case 'RA':
          return this.$t('status.RA')
        case 'CR':
          return this.$t('status.CR')
        case 'PC':
          return this.$t('status.PC')
      }
    },
    statusChangeToNo() {
      switch (this.status) {
        case 'AC':
          return 1
        case 'GU':
          return 2
        case 'WC':
          return 3
        case 'C':
          return 4
        case 'RA':
          return 5
        case 'CR':
          return 6
        case 'PC':
          return 7
      }
    },
    init() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': getServiceChargeType
        },
        (response) => {
          this.service_charge = response.resultInfo.service_fee
          this.servicefee_real = response.resultInfo.servicefee_real
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': orderInfoGetType,
              'orderNo': this.orderNo
            },
            (response) => {
              this.orderInfo = response.resultInfo
              if (this.orderInfo.receive_account_type === null) {
                this.orderInfo.receive_account_type = 1
              }
              this.orderInfo.bank_bacs_sepa = this.orderInfo.bank_bacs_sepa === 1
              this.status = this.orderInfo.order_status_code

              if (this.orderInfo.payment_evidence_id !== null) {
                this.download()
              }
              this.exchange_copper_rate = this.orderInfo.exchange_copper_rate
              this.$nextTick(() => {
                this.oldOrderInfo = { ...this.orderInfo }
              })

              $('[data-toggle="tooltip"]').tooltip()
              $(function () { $("[data-toggle='popover']").popover() })
              $('.needs-validation')[0].classList.remove('was-validated')
            },
            null
          )
        },
        null
      )
    },
    getServiceCharge() {
      if ((this.orderInfo.exchange_rate * this.orderInfo.payment_coin_amount * this.service_charge).toFixed(2) === (this.orderInfo.exchange_rate * this.orderInfo.payment_coin_amount).toFixed(2)) {
        return (this.orderInfo.exchange_rate * this.orderInfo.payment_coin_amount).toFixed(2)
      }
      return (this.orderInfo.exchange_rate * this.orderInfo.payment_coin_amount * this.service_charge).toFixed(2) > 0 ? (this.orderInfo.exchange_rate * this.orderInfo.payment_coin_amount * this.service_charge).toFixed(2) : 0.01
    },
    update() {
      if (this.newStatus === 'C') {
        let messageOperatorTemp = this.orderInfo.message_operator
        this.orderInfo = { ...this.oldOrderInfo }
        this.orderInfo.message_operator = messageOperatorTemp
        this.exchange_copper_rate = this.orderInfo.exchange_copper_rate
      }
      this.orderInfo.order_status_code = this.newStatus
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': orderInfoUpdateType,
          'orderInfo': {
            order_id: this.orderInfo.order_id,
            order_status_code: this.orderInfo.order_status_code,
            exchange_copper_rate: this.exchange_copper_rate,
            exchange_rate: this.orderInfo.exchange_rate,
            exchange_amount: this.orderInfo.exchange_amount,
            exchange_service_charge: this.orderInfo.exchange_service_charge,
            message_operator: this.orderInfo.message_operator,
            last_update_time: this.orderInfo.order_update_time
          },
          'userEmail': this.orderInfo.user_email,
          'userName': this.orderInfo.user_name,
          'notRequest': this.notRequest,
          'isSave': this.newStatus === this.status
        },
        (response) => {
          $('#successModal').modal({ backdrop: 'static', keyboard: false })
        },
        null
      )
    },
    download() {
      let data = {
        reqType: 'operator-download',
        payment_evidence_id: this.orderInfo.payment_evidence_id,
        localhost: document.domain
      }

      let xhr = new XMLHttpRequest()
      xhr.open('POST', Env.URL_HEAD + 'post')
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', 'Bearer ' + Cookies.get('tokenId'))
      xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
      xhr.send(JSON.stringify(data))
      xhr.onloadend = (event) => {
        if (xhr.status === 200) {
          let blob = new Blob([xhr.response], { type: 'image/jpeg' })
          let objectURL = URL.createObjectURL(blob)

          /* let saveAs = document.getElementById('saveAs')
                                     saveAs.download = 'hello.jpg'
                                     saveAs.href = objectURL

                                     saveAs.onclick = (event) => {
                                     // イベントをキャンセル
                                     event.preventDefault()
                                     // process
                                     } */

          this.imgURL = objectURL

          // URLオブジェクトを削除
          //   $('img')[0].onload = () => {
          //     URL.revokeObjectURL(objectURL)
          //   }
        }
      }
    },
    format() {
      if (this.exchange_copper_rate !== null && this.exchange_copper_rate !== '') {
        this.exchange_copper_rate = (parseFloat(this.exchange_copper_rate)).toFixed(2)
      }
    },
    submit(mode) {
      switch (mode) {
        case 'save':
          this.newStatus = this.status
          break
        case 'C':
          this.newStatus = 'C'
          break
        case 'AC':
          this.newStatus = 'AC'
          break
        case 'RA':
          this.newStatus = 'RA'
          break
        case 'CR':
          this.newStatus = 'CR'
          break
        case 'PC':
          this.newStatus = 'PC'
          break
      }
      if (this.newStatus === this.status || this.newStatus !== 'CR') {
        this.notRequest = true
      } else this.notRequest = false
      let formValidation = $('.needs-validation')[0]
      if (!this.notRequest) {
        formValidation.classList.add('was-validated')
        if ($('.form-control:invalid').length !== 0) $('.form-control:invalid')[0].focus()
      }
      if (this.notRequest || formValidation.checkValidity()) {
        formValidation.classList.remove('was-validated')
        $('#generalModal').modal('show')
      }
    },
    userLanguageCode(code) {
      switch (code) {
        case 'en':
          return this.$t('languageChoice.English')
        case 'jp':
          return this.$t('languageChoice.Japanese')
        case 'zh':
          return this.$t('languageChoice.Chinese')
        default:
          return this.$t('languageChoice.English')
      }
    },
    checkLower() {
      if (this.orderInfo.exchange_copper_rate !== null &&
          this.orderInfo.exchange_copper_rate !== '' &&
          (this.orderInfo.exchange_rate < this.orderInfo.exchange_estimated_rate * 0.9)) this.showLower = true
      else this.showLower = false
    }

  },
  watch: {
    exchange_copper_rate() {
      if (this.status === 'RA') {
        this.orderInfo.exchange_copper_rate = this.exchange_copper_rate
        this.orderInfo.exchange_rate = parseFloat(this.exchange_copper_rate * (1 - this.servicefee_real)).toFixed(2)
        this.orderInfo.exchange_service_charge = this.getServiceCharge()
        this.orderInfo.exchange_amount = (this.orderInfo.exchange_rate * this.orderInfo.payment_coin_amount).toFixed(2)
        this.checkLower()
      }
    }
  }
}
</script>
<style src="../../../static/css/dashboard.css" />
<style scoped>
.navbar {
  font-weight: normal;
}
.navbar-brand {
  font-size: 1.25rem;
}
.container{
  min-height:calc(100vh - 256px)
}
.change:focus{
  color:#495057;
  outline:0;
  -webkit-box-shadow:0 0 0 .2rem rgba(17,175,34,.25);
  box-shadow:0 0 0 .2rem rgba(17,175,34,.25)}
</style>



// WEBPACK FOOTER //
// src/components/operator/order-info.vue